import styled from 'styled-components';
import { SuiContainer } from '@splashthat/sui';

export default styled(SuiContainer)`
    margin-bottom: ${(props) => props.theme.questionMarginBottom};
    && {
        && {
            padding-bottom: 0;
        }
    }

    &:not(:first-child) {
        && {
            && {
                padding-top: 0;
            }
        }
    }
`;
